export const lightgreenColor="#1ABCA1";
export const  primaryColor = '#AEA1BD';
export const  primaryColorLight = "#D1CADA";
export const  primaryColorDark = '#4B4157';
export const  secondaryColor = '#E9E9E9';

export const primaryColorPurple="#8C7AA2";
export const  buttonHoverColor = "#8c7aa266";
export const  buttonColor = "#b6a9c7";
export const  fontfamily = 'Nunito Sans';